import type { PendingActionData } from "../types";

export const REGION_ACCENT_COLORS: Record<string, string> = {
  APAC: "#7C3AED",
  EMEA: "#0057B7",
  LAM: "#14B8A6",
  NAM: "#00AEEF",
};

export const DEFAULT_REGION_ACCENT_COLOR = "#64748B";

export const PARTNER_TIER_COLORS: Record<string, string> = {
  Elite: "#003087",
  Premium: "#155DFC",
  Advanced: "#155DFC",
  Select: "#51A2FF",
  Registered: "#9CCAFE",
};

export const PARTNER_PROGRAM_TIER_ORDER = [
  "Elite",
  "Advanced",
  "Select",
  "Registered",
] as const;

export const DEFAULT_TIER_COLOR = "#CBD5E1";

/** Set to true when partner search and create actions are ready on the home dashboard. */
export const SHOW_PARTNER_ECOSYSTEM_HEADER_ACTIONS = false;

/** Set to true when the partner ecosystem report link is ready on the home dashboard. */
export const SHOW_PARTNER_ECOSYSTEM_REPORT_LINK = true;

/** Report footer links are visible but non-interactive until destinations are ready. */
export const DASHBOARD_REPORT_LINKS_DISABLED = true;

/** PS Revenue ARR column is static/disabled until ARR data is available from the API. */
export const STATIC_PS_REVENUE_ARR_DISABLED = true;

export type PendingActionConfig = Omit<PendingActionData, "count"> & {
  apiKey:
    | "assesment"
    | "orders"
    | "engagement"
    | "user_approvals"
    | "app_validations";
};

export const PENDING_ACTION_CONFIG: PendingActionConfig[] = [
  {
    apiKey: "assesment",
    id: "assessment",
    title: "Assessment",
    subtitle: "Pending assessments",
    customIcon: "assessment-clipboard-white",
    isStaticDisabled: true,
  },
  {
    apiKey: "orders",
    id: "orders",
    title: "Orders",
    subtitle: "Pending orders",
    icon: "cartShopping",
    isStaticDisabled: true,
  },
  {
    apiKey: "engagement",
    id: "engagement",
    title: "Engagement",
    subtitle: "Pending engagements",
    customIcon: "engagement-document",
  },
  {
    apiKey: "user_approvals",
    id: "user-approvals",
    title: "User Approvals",
    subtitle: "Pending user approvals",
    icon: "userGroup",
    isStaticDisabled: true,
  },
  {
    apiKey: "app_validations",
    id: "app-validation",
    title: "App Validation",
    subtitle: "Pending app validations",
    customIcon: "mobile-device",
  },
];

export type IntegrationCustomIcon = "wallet-card" | "mobile-device" | "idp-shield";

export const getTechnologyCustomIcon = (
  technology: string
): IntegrationCustomIcon => {
  const normalized = technology.toLowerCase();

  if (normalized.includes("wallet")) {
    return "wallet-card";
  }

  if (normalized.includes("idp")) {
    return "idp-shield";
  }

  return "mobile-device";
};

export const slugify = (value: string): string =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
